'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectedIcon = require('./SelectedIcon');

var _SelectedIcon2 = _interopRequireDefault(_SelectedIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // NPM


var Choice = function (_Component) {
  _inherits(Choice, _Component);

  function Choice(props) {
    _classCallCheck(this, Choice);

    var _this = _possibleConstructorReturn(this, (Choice.__proto__ || Object.getPrototypeOf(Choice)).call(this, props));

    _this.getChoiceClasses = function () {
      var _this$props = _this.props,
          choiceClass = _this$props.choiceClass,
          defaultChecked = _this$props.defaultChecked,
          checkedClass = _this$props.checkedClass;

      return defaultChecked ? choiceClass + ' ' + checkedClass : choiceClass;
    };

    _this.addHoverState = function (event) {
      _this.rootRef.classList.add('hovered');
    };

    _this.removeHoverState = function (event) {
      _this.rootRef.classList.remove('hovered');
    };

    _this.handleClick = function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onClick = _this$props2.onClick;

      onClick(value);
    };

    _this.rootRef = null;

    _this.setRootRef = function (element) {
      return _this.rootRef = element;
    };
    return _this;
  }

  _createClass(Choice, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          text = _props.text,
          choiceClass = _props.choiceClass,
          checkedClass = _props.checkedClass,
          otherProps = _objectWithoutProperties(_props, ['id', 'text', 'choiceClass', 'checkedClass']);

      return _react2.default.createElement(
        'div',
        { className: this.getChoiceClasses(), ref: this.setRootRef },
        _react2.default.createElement(
          'label',
          { className: choiceClass + '-label' },
          _react2.default.createElement('input', _extends({
            className: choiceClass + '-input'
          }, otherProps, {
            onClick: this.handleClick,
            onFocus: this.addHoverState,
            onBlur: this.removeHoverState
          })),
          _react2.default.createElement(
            'span',
            null,
            text
          ),
          _react2.default.createElement(_SelectedIcon2.default, { text: text })
        )
      );
    }
  }]);

  return Choice;
}(_react.Component);

Choice.propTypes = {
  type: _propTypes2.default.oneOf(['checkbox', 'radio']).isRequired,
  text: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.any.isRequired,
  defaultChecked: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  choiceClass: _propTypes2.default.string,
  checkedClass: _propTypes2.default.string,
  name: _propTypes2.default.string
};

Choice.defaultProps = {
  onFocus: function onFocus() {
    return Choice.addHoverState;
  },
  onBlur: function onBlur() {
    return Choice.removeHoverState;
  },
  choiceClass: 'Choice',
  checkedClass: 'active'
};

exports.default = Choice;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Choice.js
// module id = 199
// module chunks = 0